/*
 * AQS lookbook — drag-to-scroll for the horizontal strip (mouse only;
 * touch/trackpad use native scroll + snap). Delegated + guarded.
 */
(function () {
  if (window.__aqsLookbookInit) return;
  window.__aqsLookbookInit = true;

  function initStrip(strip) {
    var down = false;
    var moved = false;
    var startX = 0;
    var startScroll = 0;

    strip.addEventListener('pointerdown', function (e) {
      if (e.pointerType && e.pointerType !== 'mouse') return; // let touch scroll natively
      if (e.button && e.button !== 0) return;
      down = true;
      moved = false;
      startX = e.clientX;
      startScroll = strip.scrollLeft;
    });

    strip.addEventListener('pointermove', function (e) {
      if (!down) return;
      var dx = e.clientX - startX;
      if (Math.abs(dx) > 4) {
        moved = true;
        strip.classList.add('is-dragging');
      }
      strip.scrollLeft = startScroll - dx;
    });

    function end() {
      down = false;
      strip.classList.remove('is-dragging');
    }
    strip.addEventListener('pointerup', end);
    strip.addEventListener('pointercancel', end);
    strip.addEventListener('pointerleave', function () {
      if (down) end();
    });

    // Swallow the click that follows a drag so images/links don't fire.
    strip.addEventListener(
      'click',
      function (e) {
        if (moved) {
          e.preventDefault();
          e.stopPropagation();
          moved = false;
        }
      },
      true
    );
  }

  function init() {
    document.querySelectorAll('[data-aqs-lookbook]').forEach(initStrip);
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
